// extracted by mini-css-extract-plugin
export default {"h1":"style_h1__RoTQH","h2":"style_h2__VRnTZ","divider":"style_divider__2kCoM","input_field":"style_input_field__ifcF8","button":"style_button__KKk1g"};